// extracted by mini-css-extract-plugin
export default {"tabs":"styles_tabs__uhcQM","calendarContainer":"styles_calendarContainer__scD9M","calendarLoader":"styles_calendarLoader__2ZMev"};